import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconWindWarning: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M7.73366 4.53345H6.66699V17.4375H7.73366V4.53345Z"
        fill="#222222"
      />
      <path
        d="M10.9341 5.86676L8.80078 5.6001V10.9334L10.9341 10.6668V5.86676Z"
        fill="#EF264A"
      />
      <path
        d="M13.8838 6.4873V10.0449L12.25 10.25V6.28223L13.8838 6.4873Z"
        fill="#EF264A"
        stroke="#EF264A"
        strokeWidth="0.5"
      />
      <path
        d="M15.2002 10.1335L17.3335 9.86681V6.66681L15.2002 6.40015V10.1335Z"
        fill="#EF264A"
      />
    </svg>
  )
}

export default WeatherIconWindWarning
